// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animation[data-v-0a7b95c0]  svg *{fill:currentColor;stroke:currentColor}", ""]);
// Exports
module.exports = exports;
